<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>People</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row options-bar">
						<button class="add-item" @click="addOpen = true">Add Person <i class="ss-plus ss-glyphish-filled"></i></button>
						<Search v-on:foundItems="filteredList" defaultText="Search people" :items="people" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :people="foundPerson.length ? foundPerson : people" @edit="editPeople" @history="editHistory" @delete="deletePeople"/>
				</div>
			</div>
			<Add v-if="addOpen" @close="addOpen = false"/>
			<Edit v-if="editOpen" @close="editOpen = false" :person="selected"/>
			<History v-if="historyOpen" @close="historyOpen = false" :person="selected"/>
			<Delete v-if="deleteOpen" @close="deleteOpen = false" :person="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import Search from '../Form/Search'
import List from '../People/List.vue'
import Add from '../People/Add.vue'
import Edit from '../People/Edit.vue'
import Delete from '../People/Delete.vue'
import History from '../People/History.vue'

export default { 
	components: {
		List,
		Add,
		Edit,
		Delete,
		Search,
		History
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			addOpen: false,
			historyOpen: false,
			foundPerson: []
		}
	},
	computed : {
		...mapState({
			people: state => state.people.list
		})
	},
	methods: {
		deletePeople(people) {
			this.selected = people
			this.deleteOpen = true
		},
		editPeople(people) {
			this.selected = people
			this.editOpen = true
		},
		editHistory(people) {
			this.selected = people
			this.historyOpen = true
		},
		filteredList(items) {
			if(items.length > 0) {
				this.foundPerson = items;
			} 
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const people = this.$store.dispatch('people/getList')
		const jobs = this.$store.dispatch('jobs/getList')

		Promise.all([people, jobs])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/People.vue